import { CountryIso3Code } from '@domgen/dgx-fe-i18n';

export const mockCheckoutCustomerDetails = {
  title: '',
  firstName: 'Chuck',
  lastName: 'Norris',
  personId: 'personID',
  address: {
    countryCode: CountryIso3Code.UnitedStates,
    number: '123',
    street: 'Main St',
    postalCode: '12345',
    stateCode: 'NY',
    city: 'New York',
  },
};
